import { useModel } from '@umijs/max';

export const useInitialState = () =>
  useModel('@@initialState').initialState ?? {};
